// extracted by mini-css-extract-plugin
module.exports = {"all_component":"SearchDonor_all_component__3wY1J","all_btn":"SearchDonor_all_btn__2QbHd"};